// Layout.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const Layout = ({ children, logoFile, setLogoFile, watermark, setWatermarkFile, setEventId, setUserId }) => {
    const location = useLocation();
    let selectedEventName = "Event Name";
    try {
        const fromState = location?.state?.eventTitle;
        const fromStorage = typeof window !== 'undefined' ? localStorage.getItem('currentEventTitle') : null;
        selectedEventName = (fromState || fromStorage || "Event Name");
    } catch (_) { /* ignore */ }
    const eventType = "Event type";

    return (
        <div className="App2">
            <div className="App">
                {location.pathname.startsWith('/folders') || location.pathname.startsWith('/events/') ? (
                    <Header
                        setLogoFile={setLogoFile}
                        setWatermarkFile={setWatermarkFile}
                        eventName={selectedEventName}
                        eventType={eventType}
                        setEventId={setEventId}
                        setUserId={setUserId}
                        hideAssets={location.pathname === '/folders' || /^\/folders\/[^/]+$/.test(location.pathname)}
                        showFolderBar={location.pathname.startsWith('/folders')}
                    />
                ) : null}
                <main>{children}</main>
            </div>
        </div>
    );
};

export default Layout;
